import { render } from "./PanelAdminImportStatGov.vue?vue&type=template&id=89136f72&ts=true"
import script from "./PanelAdminImportStatGov.vue?vue&type=script&lang=ts"
export * from "./PanelAdminImportStatGov.vue?vue&type=script&lang=ts"

import "./PanelAdminImportStatGov.vue?vue&type=style&index=0&id=89136f72&lang=scss"

import exportComponent from "/home/administrator/tourstat-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__